/*
We're constantly improving the code you see.
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from 'react'

export const SoundIcon = ({color, className}: {color?:string, className?: string}) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
    >
      <path
        d="M18 10.18V8C18 5.87827 17.1571 3.84344 15.6569 2.34315C14.1566 0.842855 12.1217 0 10 0C7.87827 0 5.84344 0.842855 4.34315 2.34315C2.84285 3.84344 2 5.87827 2 8V10.18C1.41645 10.3863 0.910998 10.7681 0.552938 11.2729C0.194879 11.7778 0.00173951 12.3811 0 13V15C0 15.7956 0.316071 16.5587 0.87868 17.1213C1.44129 17.6839 2.20435 18 3 18H6C6.26522 18 6.51957 17.8946 6.70711 17.7071C6.89464 17.5196 7 17.2652 7 17V11C7 10.7348 6.89464 10.4804 6.70711 10.2929C6.51957 10.1054 6.26522 10 6 10H4V8C4 6.4087 4.63214 4.88258 5.75736 3.75736C6.88258 2.63214 8.4087 2 10 2C11.5913 2 13.1174 2.63214 14.2426 3.75736C15.3679 4.88258 16 6.4087 16 8V10H14C13.7348 10 13.4804 10.1054 13.2929 10.2929C13.1054 10.4804 13 10.7348 13 11V17C13 17.2652 13.1054 17.5196 13.2929 17.7071C13.4804 17.8946 13.7348 18 14 18H17C17.7956 18 18.5587 17.6839 19.1213 17.1213C19.6839 16.5587 20 15.7956 20 15V13C19.9983 12.3811 19.8051 11.7778 19.4471 11.2729C19.089 10.7681 18.5835 10.3863 18 10.18ZM5 12V16H3C2.73478 16 2.48043 15.8946 2.29289 15.7071C2.10536 15.5196 2 15.2652 2 15V13C2 12.7348 2.10536 12.4804 2.29289 12.2929C2.48043 12.1054 2.73478 12 3 12H5ZM18 15C18 15.2652 17.8946 15.5196 17.7071 15.7071C17.5196 15.8946 17.2652 16 17 16H15V12H17C17.2652 12 17.5196 12.1054 17.7071 12.2929C17.8946 12.4804 18 12.7348 18 13V15Z"
        fill={color? color: "black"}
      />
    </svg>
  )
}
